import ComponentBase from "../../../../public/component/component_base";

import * as GameProto from "../../../net/proto/proto_bullbull_game";
import BullCardValueCom from "./bull_card_value_com";
import CardMoveCom from "./card_move_com";
import EventManager from "../../../../../manager/event_manager";
import AudioManager from "../../../../../manager/audio_manager";
import BullBullConst from "../../utils/bullbull_const";
import ModelData from "../../../../public/model_data";
import TablePokerBase from "../../../../table/module/table_base/table_poker_base";
import BullTurnNumCom from "./bull_turn_num_com";
const {ccclass, property} = cc._decorator;

@ccclass
//搓牌组件
export default class BullRobCardCom extends TablePokerBase {
    
    @property(cc.Node)
    cardNode : cc.Node = null;

    @property(cc.Node)
    robCardNode : cc.Node = null;

    @property(cc.Node)
    maskNode : cc.Node = null;

    @property(cc.Node)
    faceNode : cc.Node = null;

    @property(cc.Label)
    timeLab : cc.Label = null;

    @property([BullTurnNumCom])
    turnNums: BullTurnNumCom[] = [];

    private preLocation : cc.Vec2;

    private showFaceAni : boolean;

    private readonly MAX_ANGLE : number = -2;

    private readonly MIN_ANGLE : number = 11;

    private readonly LIMIT_ANGLE : number = -20;

    private overLimit : boolean = false;

    private showTimeLab : boolean = false;
    
    private pokerNumber : string;

    private showTurnNum : boolean;

    start(){

        this.showFaceAni = false;

        this.robCardNode.on(cc.Node.EventType.TOUCH_START,this.touchStart,this);
        this.robCardNode.on(cc.Node.EventType.TOUCH_MOVE,this.touchCheck,this);
        this.robCardNode.on(cc.Node.EventType.TOUCH_END,this.touchEnd,this);
        this.robCardNode.on(cc.Node.EventType.TOUCH_CANCEL,this.touchEnd,this);

        
    }

    

    onEnable(){

        this.robCardNode.position = new cc.Vec3(-50.826,-183.395);
        this.robCardNode.angle = 13;
        this.robCardNode.active = true;
        this.robCardNode.scale = 1;

        this.cardNode.active = true;
        this.cardNode.angle = 15;
        this.cardNode.scale = 1;

        this.maskNode.active = true;

        this.showTimeLab = true;

        this.robCardNode.stopAllActions();
        
        this.overLimit = false;

        this.showTurnNum = false;

        this.timeLab.node.active = false;

        this.playBackAni("anim_niuniu_cuopai1");

        this.cardNode.resumeAllActions();
        this.cancelAllSchedule();
    }


    updateTime( time : number ){
        

        // if (this.showTimeLab) {
        //     this.timeLab.node.active = true;    
        // }
        
        // this.timeLab.string = time.toString(); 

        if (!this.showTurnNum) {
        
            this.turnNums[0].show(  time  );
            this.turnNums[1].show(  time - 1);

            // this.turnNums[2].show( time % 10 );
            // this.turnNums[3].show( time % 10 - 1);

            this.timeLab.node.active = true;    
        }
        
        this.showTurnNum = true;

    }

    onDisable(){

        this.cardNode.resumeAllActions();
        this.cancelAllSchedule();

        this.showTimeLab = false;
        this.showTurnNum = false;
    }

    private playBackAni(aniName : string){

        let ani = this.robCardNode.getComponent(cc.Animation);

        ani.resume();
        ani.play(aniName);
    }

    updateCard(playerId : number, poker : GameProto.BullBullGame.IPoker){
        
        let com = this.cardNode.getComponent(BullCardValueCom);
        com.updateCard(ModelData.instance.roleData.id,poker.number,poker.colour);

        this.pokerNumber = poker.number;

        this.showFaceAni = false;

        this.uid = playerId;

        this.onUpdateBack();

        //this.showFaceElement(false);
    }

    private touchStart(event){

        this.preLocation = event.touch.getLocation();        

        this.playBackAni("anim_niuniu_cuopai2");
    }

    private showFaceElement(state : boolean){

        this.faceNode.children.forEach(child => {
            
            child.active = state;
        });
    }


    private touchCheck(event : cc.Event.EventTouch){        

        let location = event.touch.getLocation();       

        let dir = location.sub(this.preLocation);
        //let dir = location.sub(preLocation);

        //dir = event.touch.getDelta();
        
        // let dir = new cc.Vec2(location.x - this.gestureStart.x,
        //                       location.y - this.gestureStart.y);
                
                      
        this.preLocation = location;

        if (!dir.mag()) {
            return;
        }

        let angle = (dir.angle(cc.Vec2.RIGHT) * 180 / Math.PI);
        let dis = dir.mag();

        //console.log( " dir " , dir,  " angle " , angle , " dis " , dis);

        if (!dir || !dis) {
            return;
        }        

        //this.moveDir = moveDir;

        
        if (angle < 60 && angle > - 60) {            
       
            //console.log(" move right ... ");

            if (!this.overLimitAngle()) {
                this.robCardNode.angle -= 0.7;    
            }

            this.robCardNode.stopAllActions();

        
        }
        else if(angle > 120 && angle < 240){

            //console.log(" move left ... ");

            this.robCardNode.angle += 0.7;

            this.robCardNode.stopAllActions();

            if(this.lessMinAngle()){

                this.robCardNode.angle = this.MIN_ANGLE;
            }    

        }

    }

    private touchEnd(event : cc.Event.EventTouch){

        if (!this.overLimit) {
            //弹回去
            this.robCardNode.runAction(cc.rotateTo(0.7,15));            
        }

        if (this.overMaxAngle()) {
                
            this.overLimit = true;

            this.robCardNode.active = false;

            let rotate = cc.rotateTo(0.25,0);

            let number = BullBullConst.POKER_NUMBER_MAP[this.pokerNumber];
            AudioManager.instance.playSound(`package/longhudou/sound/${number}_dian`)

            let self = this;
            this.cardNode.runAction(cc.sequence(rotate,cc.callFunc(()=>{
                self.doScheduleOnce(()=>{

                    //self.node.active = false;
                    self.maskNode.active = false;
                    self.timeLab.node.active = false;
                    self.showTimeLab = false;                    

                    let cardMove = self.cardNode.getComponent(CardMoveCom);
                    cardMove.moveTo(0.8,null,()=>{
                        self.node.active = false;
                        EventManager.instance.dispatch("event_rob_card_finish");

                    },  174 / 407, 230 / 546);

                },1)
            })));
        }     
        
    }
    

    private overMaxAngle(){

        return this.robCardNode.angle < this.MAX_ANGLE;        
    } 

    private lessMinAngle(){

        return this.robCardNode.angle > this.MIN_ANGLE;        
    }

    private overLimitAngle(){

        return this.robCardNode.angle < this.LIMIT_ANGLE;  
    }

    

}